import React from "react";
import { Link } from "react-router";
import { ExternalLink } from "lucide-react";

const schemeLinks = [
  {
    label: "Credit Line-1:",
    path: "/schemes/nmdfc-schemes",
  },
  {
    label: "Credit Line-2:",
    path: "/schemes/nmdfc-schemes",
  },
  {
    label: "V. PROMOTIONAL SCHEME:",
    path: "/schemes/promotional-schemes",
    heading: true,
  },
  {
    label: "VI. VIRASAT SCHEME:",
    path: "/schemes/virasat-scheme",
    heading: true,
  },
];

const SectionHeading = ({ children }) => (
  <h3 className="mb-2 text-[14px] font-bold uppercase leading-6 text-[#123764] underline underline-offset-2">
    {children}
  </h3>
);

const SchemeLink = ({ label, path, heading = false }) => (
  <div className={heading ? "flex items-center gap-3" : ""}>
    {heading ? (
      <span className="text-[14px] font-bold uppercase text-[#123764] underline underline-offset-2">
        {label}
      </span>
    ) : (
      <span>{label}</span>
    )}
    <Link
      to={path}
      className="inline-flex items-center gap-2 text-[#123764] underline underline-offset-2 hover:text-[#0f8a7e] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#0f8a7e] focus-visible:ring-offset-2"
    >
      Click here
      <ExternalLink size={16} strokeWidth={2} />
    </Link>
  </div>
);

const ChapterThirteenContent = () => (
  <article className="min-w-0 flex-1 space-y-7 px-1 pb-8 font-sans text-[14px] leading-7 text-[#123764]">
    <header>
      <h2 className="mb-2 text-[20px] font-bold leading-7 text-[#006461]">
        Chapter 13 : Manner of execution of subsidy programmes [SECTION
        4(1)(B)(xii)]
      </h2>
      <p className="font-bold">
        The manner of execution of subsidy programmes:
      </p>
    </header>

    <section>
      <SectionHeading>I. Introduction</SectionHeading>
      <p>
        NATIONAL MINORITIES DEVELOPMENT AND FINANCE CORPORATION (NMDFC) was
        incorporated as a Government Company, on September 30, 1994 under
        Ministry of Social Justice & Empowerment as a Company not for profit
        under Section 25 of the Companies Act, 1956 (Now Section 8 under
        Companies Act, 2013). It is a "C" Schedule Company operating in social
        sector under the administrative control of Ministry of Minority Affairs,
        Government of India. NMDFC is working under the aegis of Ministry of
        Minority Affairs since 2006.
      </p>

      <p className="mt-6">
        The Corporation has been set up to promote economic and developmental
        activities for the benefit of "Backward Sections" amongst the
        minorities, preference being given to the occupational group and women.
        The Muslims, Christians, Sikhs, Buddhists, Parsis and Jains have been
        notified as minorities by the Central Government under the National
        Minorities Commission Act, 1992.
      </p>
    </section>

    <section>
      <SectionHeading>II. Mandate of NMDFC</SectionHeading>
      <ul className="ml-6 list-disc space-y-1">
        <li>
          The mandate of the Corporation is to provide concessional credit for
          self-employment activities to the backward sections amongst the
          minorities.
        </li>
        <li>
          The benefits under the scheme are available for persons having annual
          family income of upto Rs.3,00,000/-.
        </li>
        <li>
          At present, the families having annual income up to Rs. 3,00,000/- are
          eligible under the NMDFC schemes. As a special initiative of NMDFC, a
          new annual family income eligibility limit of up to Rs. 8.00 lacs has
          been enhanced with effect from November, 2020 by adopting the "Creamy
          Layer" criterion currently followed amongst the OBC community by
          Government of India.
        </li>
      </ul>
    </section>

    <section>
      <SectionHeading>III. State Channelising Agencies (SCAs)</SectionHeading>
      <p>
        The State Channelising Agencies (SCAs) are the main channel for
        implementing the schemes of NMDFC. The individual beneficiaries are
        assisted through the SCAs under the Term Loan, Educational Loan, and
        Micro Finance Schemes & Mahila Samridhi Yojana of NMDFC. The SCAs are
        nominated by the respective State Governments / UT Administrations. Funds
        to SCAs are released against Sovereign Guarantee issued by respective
        State Govts. / UT Administration.
      </p>

      <p className="mt-6">
        At present, NMDFC has 45 SCAs in 27 States & 8 UT Administrations.
        Presently, 39 SCAs are operational while 6 SCAs are in-operational
        mainly due to reasons like not signing of General Loan Agreement &
        furnishing of Government Guarantee by the respective State Government/UT
        Administrations. The SCAs are in-operational in the States/UTs of
        Arunachal Pradesh, Meghalaya, A&N islands, Daman & Diu, Lakshadweep &
        D&N Haveli. Government of Telangana is yet to nominate an agency for
        implementation of NMDFC schemes in the State.
      </p>
    </section>

    <section>
      <SectionHeading>IV. Self Employment Lending Scheme</SectionHeading>
      <ul className="ml-6 list-disc space-y-3">
        {schemeLinks.slice(0, 2).map((link) => (
          <li key={link.label}>
            <SchemeLink {...link} />
          </li>
        ))}
      </ul>
    </section>

    <section className="space-y-4">
      {schemeLinks.slice(2).map((link) => (
        <SchemeLink key={link.label} {...link} />
      ))}
    </section>
  </article>
);

export default ChapterThirteenContent;
